import { useTranslation } from "~/i18n"
import Box from "~/components/UI/Box"
import Text from "~/components/UI/Text"
import SharedTitle from "~/components/UI/SharedTitle"
import { Container } from 'react-bootstrap'
import styled from "styled-components"
import Link from "../UI/Link"
import Button from "../UI/Button"
import { observer } from 'mobx-react-lite'
import state from "./State"
import dayjs from "dayjs"
import utc from 'dayjs/plugin/utc'
import Currency from "../Currency"
dayjs.extend(utc)

const Row = styled(Box) <{ isOdd?: boolean }>`
  background: ${p => p.isOdd ? 'rgba(235, 243, 255, 0.4)' : '#fff'};
  padding: 12px 20px;
`

const Table = styled(Box)`
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 4px 0;
  overflow: hidden;
  max-width: 880px;
`

const DetailTable = styled(Box)`
  margin: 48px auto;
  max-width: 880px;
`

const CDResult: React.FC<{}> = () => {
  const [t] = useTranslation()
  const cd = state.cd
  const details = [
    {
      title: t('Đơn vị phát hành'),
      value: cd?.developer.name
    },
    {
      title: t('Đơn vị quản lý'),
      value: cd?.management_company
    },
    {
      title: t('Lãi suất'),
      value: ((cd?.offer.interest_rate || 0) * 100).toFixed(2) + '%' + t('năm')
    },
    {
      title: t('Kỳ hạn'),
      value: cd?.offer.interest_term + ' ' + t('tháng')
    },
    {
      title: t('Ngày phát hành'),
      value: dayjs.utc(cd?.offer.term_start_date).format('DD/MM/YYYY')
    },
    {
      title: t('Ngày đến hạn'),
      value: dayjs.utc(cd?.offer.term_end_date).format('DD/MM/YYYY')
    },
    {
      title: t('Phương thức trả lãi'),
      value: t('Cuối kỳ')
    },
    {
      title: t('Tổng mệnh giá'),
      value: <Currency style={{ flex: 1, fontWeight: 'bold' }} value={cd?.offer.property_price} />
    }
  ]

  const documentNames = {
    cd: t('Bản chụp Chứng chỉ tiền gửi'),
    contract: t('Bản chụp Hợp đồng Infina và ACBC'),
    transaction: t('Bản chụp giao dịch thanh toán')
  }

  const detailTable = details.map((item, index) => {
    return (
      <Row key={item.title} isOdd={index % 2 === 0} flex>
        <Text style={{ flex: 1 }}>
          {item.title}
        </Text>
        {typeof item.value === 'string' ? (
          <Text style={{ flex: 1 }} bold>
            {item.value}
          </Text>
        ) : item.value}
      </Row>
    )
  })

  const documentTable = Array.isArray(state.cd?.documents) && state.cd?.documents.map((item, index) => {
    return (
      <Row key={index} isOdd={index % 2 === 0} flex>
        <Text style={{ width: '70%' }}>
          {item.title}
        </Text>
        <Link href={item.url} target='_blank'>
          {t('Xem ảnh >')}
        </Link>
      </Row>
    )
  })


  const listTable = Array.isArray(state.cd?.investment_packages) && state.cd?.investment_packages.map((item, index) => {
    return (
      <Row key={item.package_id} isOdd={index % 2 === 0} flex>
        <Text bold style={{ flex: 1 }}>
          {item.package_id}
        </Text>
        <Text bold style={{ flex: 2 }}>
          {item.user.name}
        </Text>
        <Text bold style={{ flex: 1 }}>
          {item.investment_percent}%
        </Text>
      </Row>
    )
  })

  return (
    <Container style={{ marginBottom: 50 }}>
      <Box flex column align='center' justify='center'>
        <SharedTitle bold>
          {t('Thông tin chứng chỉ')}
        </SharedTitle>
        <Text size={24}>
          {t('Số seri')}: <strong>{state.cd?.seri_number}</strong>
        </Text>
      </Box>

      {/* detail table */}
      <DetailTable >
        <Text margin='16px 0' bold>
          {t('Thông tin chi tiết')}
        </Text>
        <Table>
          {detailTable}
        </Table>
      </DetailTable>


      {/* detail table */}
      <DetailTable >
        <Text margin='16px 0' bold>
          {t('Hồ sơ tài liệu')}
        </Text>
        <Table>
          {documentTable}
        </Table>
      </DetailTable>


      {/* detail table */}
      <DetailTable >
        <Text margin='16px 0' bold>
          {t('Danh sách nhà đầu tư')}
        </Text>
        <Table>
          <Box style={{ padding: '0 20px' }} flex>
            <Text style={{ flex: 1 }}>
              {t('Mã đầu tư')}
            </Text>
            <Text style={{ flex: 2 }}>
              {t('Nhà đầu tư')}
            </Text>
            <Text style={{ flex: 1 }}>
              {t('Tỉ lệ đầu tư')}
            </Text>
          </Box>
          {listTable}
        </Table>
      </DetailTable>
      <Button onClick={state.reset} style={{ margin: 'auto', width: 320 }} border='0' primary>
        <Text color='#fff'>
          {t('Thử Với Số Seri Khác')}
        </Text>
      </Button>
    </Container>
  )
}

export default observer(CDResult)
